<template>
  <v-btn
    :loading="loading"
    dark
    small
    absolute
    top
    right
    @click="getScreenShot('GeneralVisitors')"
  >
    <b>export</b>
    <v-icon class="ml-1" size="20">mdi-tray-arrow-down</v-icon>
  </v-btn>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  name: "ExportBTN",
  data() {
    return {
      loading: false,
    };
  },
  props: {
    element: String,
    default: () => "",
  },
  methods: {
    getScreenShot() {
      this.loading = true;
      this.$store.dispatch("setCloader", { showing: true });
      let c = document.getElementById(this.element);

      html2canvas(c)
        .then(async (canvas) => {
          var t = canvas.toDataURL().replace("data:image/png;base64,", "");
          await this.downloadBase64File("image/png", t, "image");
          this.$store.dispatch("setCloader", { showing: false });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("setCloader", { showing: false });
          this.loading = false;
        });
    },
    downloadBase64File(contentType, base64Data) {
      let format = new Date().toLocaleString([], {
        dateStyle: "full",
        timeStyle: "short",
      });
      const linkSource = `data:${contentType};base64,${base64Data}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = `${this.element}-${format}`;
      downloadLink.click();
    },
  },
};
</script>
